import { create } from 'zustand';

export interface AdminNotification {
  id: string;
  type: 'handoff_requested' | 'merchant_notification' | 'handoff_resolved';
  title: string;
  message: string;
  urgency: 'low' | 'medium' | 'high' | 'critical';
  workspaceId?: string;
  conversationId?: string;
  timestamp: Date;
  read: boolean;
}

interface AdminNotificationState {
  notifications: AdminNotification[];
  unreadCount: number;
  sseConnected: boolean;

  addNotification: (notification: Omit<AdminNotification, 'id' | 'read'>) => void;
  markAsRead: (id: string) => void;
  markAllRead: () => void;
  setSseConnected: (connected: boolean) => void;
  clearNotifications: () => void;
}

export const useAdminNotificationStore = create<AdminNotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  sseConnected: false,

  addNotification: (notification) =>
    set((state) => ({
      notifications: [
        { ...notification, id: crypto.randomUUID(), read: false },
        ...state.notifications,
      ],
      unreadCount: state.unreadCount + 1,
    })),

  markAsRead: (id) =>
    set((state) => {
      const notification = state.notifications.find((n) => n.id === id);
      if (!notification || notification.read) return state;

      return {
        notifications: state.notifications.map((n) =>
          n.id === id ? { ...n, read: true } : n
        ),
        unreadCount: state.unreadCount - 1,
      };
    }),

  markAllRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, read: true })),
      unreadCount: 0,
    })),

  setSseConnected: (connected) =>
    set({ sseConnected: connected }),

  clearNotifications: () =>
    set({ notifications: [], unreadCount: 0 }),
}));
